import React, { useMemo, useState } from "react";
import {
  Card, CardHeader, CardBody, Button, Input,
} from "reactstrap";

import TableContainer from "../../../Components/Common/TableContainer";
const ReservationTable = ({
  filteredBookings, setSelectedBooking, reservationSearch, setReservationSearch, reservationSource, setReservationSource, todayCheckIn,
  todayDeparture, upcomingCheckIn, upcomingDeparture, cancelledCount, handleCreate, selectedRows, setSelectedRows,
}) => {
  const [page, setPage] = useState(1);

const otaOptions = useMemo(() => {
  const channels = [
    ...new Set(
      filteredBookings
        .map((b) => b.channel)
        .filter(Boolean)
    ),
  ];

  return channels.sort();
}, [filteredBookings]);

  const columns = useMemo(
    () => [
      {
        id: "select",
        header: () => (
          <Input
            type="checkbox"
            checked={
              filteredBookings.length > 0 &&
              selectedRows.length ===
              filteredBookings.length
            }
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedRows(
                  filteredBookings.map(
                    (b) => b._id
                  )
                );
              } else {
                setSelectedRows([]);
              }
            }}
          />
        ),

        cell: ({ row }) => (
          <Input
            type="checkbox"
            checked={selectedRows.includes(
              row.original._id
            )}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedRows([
                  ...selectedRows,
                  row.original._id,
                ]);
              } else {
                setSelectedRows(
                  selectedRows.filter(
                    (id) =>
                      id !==
                      row.original._id
                  )
                );
              }
            }}
            onClick={(e) =>
              e.stopPropagation()
            }
          />
        ),
      },

      {
        header: "Booking ID",
        accessorKey: "bookingId",
        cell: ({ row }) => (
          <span
            className="fw-semibold text-primary"
            style={{
              cursor: "pointer",
            }}
            onClick={() =>
              setSelectedBooking(
                row.original
              )
            }
          >
            {row.original.bookingId?.slice(-5)}
          </span>
        ),
      },

      {
        id: "bookingDate",
        header: "Booking Date",
        accessorFn: (row) =>
          row.bookingDate
            ? new Date(
              row.bookingDate
            ).toLocaleDateString()
            : "-",
      },

      {
        header: "Name",
        accessorKey: "name",
      },

      {
        header: "Email",
        accessorKey: "email",
      },

      {
        header: "Mobile",
        accessorKey: "mobile",
      },



      {
        id: "channel",
        header: "OTA",
        accessorFn: (row) =>
          row.channel || "-",
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: ({ row }) => {
          const status =
            row.original.status || "";

          let badgeClass =
            "badge bg-success-subtle text-success";

          if (
            status.toLowerCase() ===
            "pending"
          ) {
            badgeClass =
              "badge bg-warning-subtle text-warning";
          }

          if (status.toLowerCase() === "checked in") {
            badgeClass =
              "badge bg-success-subtle text-success";
          }

          if (status.toLowerCase() === "checked out") {
            badgeClass =
              "badge bg-secondary-subtle text-secondary";
          }

          if (
            status.toLowerCase() ===
            "cancelled"
          ) {
            badgeClass =
              "badge bg-danger-subtle text-danger";
          }

          return (
            <span className={badgeClass}>
              {status}
            </span>
          );
        },
      },

      {
        header: "Notes",
        accessorFn: (row) =>
          row.notes || "-",
      },

      {
        header: "Special Request",
        accessorFn: (row) =>
          row.specialRequest || "-",
      },


    ],
    [setSelectedBooking]
  );

  return (
    <div className="col-md-8 ps-0">
      <Card style={{
        borderRadius: "6px",
      }}>
        <CardHeader className="border-bottom py-2">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 p-3">
            <div
              className="d-flex gap-2 flex-wrap"
              style={{ flex: 1 }}
            >
              <Input
                type="text"
                placeholder="Search Reservation..."
                value={reservationSearch}
                onChange={(e) =>
                  setReservationSearch(
                    e.target.value
                  )
                }
                bsSize="sm"
                style={{
                  width: "260px",
                  height: "32px",
                }}
              />

              <Input
                type="select"
                value={reservationSource}
                onChange={(e) =>
                  setReservationSource(e.target.value)
                }
                bsSize="sm"
                style={{
                  width: "180px",
                  height: "32px",
                }}
              >
                <option value="ALL">
                  All Sources
                </option>

                {otaOptions.map((channel) => (
                  <option
                    key={channel}
                    value={channel}
                  >
                    {channel}
                  </option>
                ))}
              </Input>
            </div>


          </div>
        </CardHeader>

        {/* BODY */}
        <CardBody className="p-0">
          {/* TABLE */}
          <div
            className="table-responsive reservation-table"
          >
            <TableContainer
              columns={columns}
              data={
                filteredBookings
              }
              className="text-nowrap"
              tbodyTrProps={(
                row
              ) => ({
                style: {
                  cursor:
                    "pointer",
                },
                onClick: () =>
                  setSelectedBooking(
                    row.original
                  ),
              })}
            />

          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default ReservationTable;